import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import * as _moment from 'moment';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
import { truncate } from 'fs';
export class EvaluationStructureData {
  id: number;
  IsNotice: boolean;
  IsCase: boolean;
  IsDecision: boolean;
  ParameterCaption: string;
  ParameterType: string;
  ParameterDefaultValue: string;
  ParameterValue: string;
  ParameterPosition: number;
  recEnable: boolean;
}

export class FetchEvaluationStructureData {
  id: number;
  Caption: string;
  Type: string;
  IsNotice: boolean;
  IsCase: boolean;
  IsDecision: boolean;
  DefaultValue: string;
  Value: string;
  Position: number;
  recEnable: boolean;
}

export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
    selector: 'app-evaluation-structure',
    templateUrl: './evaluation-structure.component.html',
    styleUrls: ['./evaluation-structure.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class EvaluationStructureComponent implements OnInit {
  InsertEvaluationForm: FormGroup;
  EvaluationForm: FormGroup;
  url: string;
  TypeValue: string;
  CaseChk: string;
  DecisionChk: string;
  NoticeChk: string;
  pageurl: string;
  id: any;
  recEnable: any;
  ControlPosition: any;
  EvaluationData: string;
  IsNotice: any;
  IsCase: any;
  IsDecision: any;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.InsertEvaluationForm = this.formBuilder.group ({Caption: [''], ParamterType: [''], DefaultValue: [''], DropDownValue: [''],
    Position: [''], ChkCase: [''], ChkDecision: [''], ChkNotice: [''], IsActive: [''] });
    this.InsertEvaluationForm.patchValue({ParamterType: "0"});
    this.TypeValue = "0";
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[2];
    alert(this.id);
    if(this.id>0){
      this.fetchExistingStructureData();
    }
    this.IsNotice = "";
    this.IsCase = "";
    this.IsDecision = "";
  }
  onTypeChange(SelectedValue) {
    this.TypeValue = SelectedValue;
  }
  fetchExistingStructureData(){
    this.http.get(this.url + 'EvalForm/FetchEvaluationStructurebyID?id='+this.id)
    .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {
          const fetchEvaluationStructureData: FetchEvaluationStructureData = null;
         } else {
          const fetchEvaluationStructureData: FetchEvaluationStructureData = JSON.parse(data.toString())[0];
          console.log(fetchEvaluationStructureData);
          this.TypeValue = fetchEvaluationStructureData.Type;
          this.InsertEvaluationForm.patchValue({
            Caption: fetchEvaluationStructureData.Caption, ParamterType: fetchEvaluationStructureData.Type,
            DefaultValue: fetchEvaluationStructureData.DefaultValue, DropDownValue: fetchEvaluationStructureData.Value,
            Position: fetchEvaluationStructureData.Position, IsActive: fetchEvaluationStructureData.recEnable,
            ChkCase: fetchEvaluationStructureData.IsCase , ChkDecision: fetchEvaluationStructureData.IsDecision,
            ChkNotice: fetchEvaluationStructureData.IsNotice });

           }
      }
    );
  }
  onSubmit(formValue) {
    this.IsNotice = "0";
    this.IsCase = "0";
    this.IsDecision = "0";
    if (formValue.ChkCase == false){this.IsCase = "0";} else {this.IsCase = "1"; }
    if (formValue.ChkDecision == false){this.IsDecision = "0";} else  {this.IsDecision = "1";}
    if (formValue.ChkNotice == false) {this.IsNotice = "0";} else {this.IsNotice = "1"; }
    if (formValue.Caption == "") {
      this.alertService.warn('Please Enter Caption for Parameter',this.options);
       return;
    }
    if (formValue.ParamterType == "0") {
      this.alertService.warn('Please Select Parameter Type',this.options);
       return;
    }
    if (formValue.ChkCase == false && formValue.ChkDecision == false && formValue.ChkNotice == false ) {
      this.alertService.warn('Please select Parameter For Case,Decision,Notice',this.options); return;
    } else {
      if((this.TypeValue=="SHLP" && formValue.DropDownValue=='')|| (this.TypeValue=="MHLP" && formValue.DropDownValue==''))
      {
        this.alertService.warn('Firstly Add Data in Value Format',this.options); return;
      }
      if (formValue.IsActive == false) {this.recEnable = 0; } else { this.recEnable = 1; }
      if (formValue.Position == "") { this.ControlPosition = 0; } else { this.ControlPosition = formValue.Position; }
      let evaluationStructureData: EvaluationStructureData = {
      id: this.id,
      IsNotice: this.IsNotice,
      IsCase: this.IsCase,
      IsDecision: this.IsDecision,
      ParameterCaption: formValue.Caption,
      ParameterType: this.TypeValue,
      ParameterDefaultValue: formValue.DefaultValue,
      ParameterValue: formValue.DropDownValue,
      ParameterPosition: this.ControlPosition,
      recEnable: this.recEnable
      };
      alert(this.id);
      this.http.post(this.url + 'EvalForm/InsertUpdateEvaluationStructure', evaluationStructureData) .subscribe( (data) => {
              if (data == null) {
                this.alertService.error('Parameter Not Submitted',true);
              } else {
                if (this.id == "0")  {
                  this.alertService.success('Parameter Submitted',this.options);
                  } else {
                    this.alertService.success('Parameter Updated',this.options);
                     }
              }
             }
           );

    }


  }

}
